import React from 'react'
import { Button, Heading, Section } from 'components'
import parseHtml from 'utils/parseHtml'
import TempImage from 'utils/TempImage'
import * as Styles from './TextMedia.module.css'

const TextMedia = ({
  kicker,
  heading,
  text,
  buttons,
  backgroundColor,
  media,
}) => {
  return (
    <Section background={backgroundColor}>
      <div
        className={`${Styles.wrapper} ${
          'left' === media?.align ? Styles.alignLeft : ''
        }`}
      >
        <div className={Styles.media}>
          {/* Placeholder */}
          {media?.type?.name === 'placeholder' && (
            <div className={Styles.placeholder}>Image</div>
          )}

          {/* Embed */}
          {media?.type?.name === 'embed' && (
            <div className={Styles.podcast}>
              {parseHtml(media?.type?.embed)}
            </div>
          )}

          {/* Image */}
          {media?.type?.name === 'image' && (
            <div className={Styles.image}>
              <TempImage image={media?.type?.image} />
            </div>
          )}
        </div>

        <div className={Styles.content}>
          <Heading type="kicker">{kicker}</Heading>
          <Heading>{heading}</Heading>
          <div className={Styles.text}>{parseHtml(text)}</div>

          <div className={Styles.buttonWrapper}>
            {buttons.map((button) => (
              <Button
                key={button.label}
                type={button.type}
                to={button.destination.uri}
                icon={button.icon}
              >
                {button.label}
              </Button>
            ))}
          </div>
        </div>
      </div>
    </Section>
  )
}

export default TextMedia
